import _ from "lodash"

import { deepCamelizeKeys } from "@/utils"

import * as FlatRatesheet from "./FlatRatesheet"
import Pricing from ".."

export const KIND = "Pricing::SelectableRatesheet"

export const newRatesheet = (existingRatesheet = undefined) => {
  if (existingRatesheet) {
    return _.cloneDeep(deepCamelizeKeys(existingRatesheet))
  }

  const ratesheet = Pricing.newRatesheet({ kind: FlatRatesheet.KIND })

  return { kind: KIND, ratesheet }
}

const updateRatesheet = (ratesheet, ...updates) => _.assign(newRatesheet(ratesheet), ...updates)

// A selectable sheet wraps the concrete sheet the user picked; anything else
// is already concrete.
export const innerRatesheet = (value) => (value?.kind === KIND ? value.ratesheet : value)

const innerRatesheetAPI = ({ ratesheet: { kind } }) => Pricing.CONFIG[kind].api

export const newTier = (tier = {}, ratesheet = undefined) =>
  innerRatesheetAPI(ratesheet).newTier(tier)

export const addTier = (ratesheet, tier) =>
  updateRatesheet(ratesheet, {
    ratesheet: innerRatesheetAPI(ratesheet).addTier(ratesheet.ratesheet, tier),
  })

export const addCategory = (ratesheet, category) =>
  updateRatesheet(ratesheet, {
    ratesheet: innerRatesheetAPI(ratesheet).addCategory(ratesheet.ratesheet, category),
  })
